export default {
      id: "common__server-critical-connection-usage",
      viewBox: "0 0 30 24",
      url: __webpack_public_path__ + "img/icons.svg#common__server-critical-connection",
      toString: function () {
        return this.url;
      }
    }